import React from "react";
import { gql } from "@apollo/client";
import { Price } from "@syos-music/common";

import { styled, Box, Stack, Typography } from "@mui/material";
import { Cart as CartIcon } from "mdi-material-ui";

import SidebarItem from "./SidebarItem";

import PaymentProviderIcon from "./cart/PaymentProviderIcon";
import AddProduct from "./cart/AddProduct";
import CartContent from "./cart/CartContent";
import DiscountCode from "./cart/DiscountCode";
import Shipping from "./cart/Shipping";
import DeferredPayment from "./cart/DeferredPayment";
import B2B from "./cart/B2B";
import Billing from "./cart/Billing";

const Block = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),

  "&:empty": { padding: 0 },
}));

export default function OrderSidebarCart({ order }) {
  return (
    <SidebarItem
      icon={<CartIcon />}
      title="Panier"
      titleChildren={<PaymentProviderIcon order={order} />}
      startExpanded
    >
      <Block>
        <AddProduct order={order} />
      </Block>

      <CartContent order={order} />

      <Block>
        <Stack spacing={1}>
          <DiscountCode order={order} />

          <Shipping order={order} />

          <Stack direction="row" alignItems="center">
            <Typography sx={{ flexGrow: 1 }}>Total&nbsp;:</Typography>

            <Typography>
              <strong>
                <Price {...order.total} />
              </strong>
            </Typography>
          </Stack>

          <DeferredPayment order={order} />

          <B2B order={order} />

          <Billing order={order} />
        </Stack>
      </Block>
    </SidebarItem>
  );
}

OrderSidebarCart.fragments = {
  order: gql`
    fragment OrderSidebar_Cart_order on Order {
      id

      total {
        value
        currency
      }

      ...OrderSidebar_Cart_PaymentProviderIcon_order
      ...OrderSidebar_Cart_AddProduct_order
      ...OrderSidebar_Cart_CartContent_order
      ...OrderSidebar_Cart_DiscountCode_order
      ...OrderSidebar_Cart_Shipping_order
      ...OrderSidebar_Cart_DeferredPayment_order
      ...OrderSidebar_Cart_B2B_order
      ...OrderSidebar_Cart_Billing_order
    }

    ${PaymentProviderIcon.fragments.order}
    ${AddProduct.fragments.order}
    ${CartContent.fragments.order}
    ${DiscountCode.fragments.order}
    ${Shipping.fragments.order}
    ${DeferredPayment.fragments.order}
    ${B2B.fragments.order}
    ${Billing.fragments.order}
  `,
};
